import { render, staticRenderFns } from "./PolicyDocument.vue?vue&type=template&id=0b74baaf&scoped=true"
import script from "./PolicyDocument.vue?vue&type=script&lang=js"
export * from "./PolicyDocument.vue?vue&type=script&lang=js"
import style0 from "./PolicyDocument.vue?vue&type=style&index=0&id=0b74baaf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b74baaf",
  null
  
)

export default component.exports